export default __webpack_public_path__ + "static/media/M17.8b4cf86e.svg";